import { UserModel } from './UserModel';
import { RepeatModel } from './RepeatModel';
import { BreakdownModel } from './BreakdownModel';

export class WorkoutModel {
    constructor(workoutData) {
        const user = this.getWorkoutUser(workoutData);
        const exercises = this.getExercises(workoutData);
        const repeat = this.getRepeatData(workoutData);
        const gym = this.getGym(workoutData);

        this._workout = {
            id: workoutData.id,
            userId: workoutData.user_id,
            totalBpm: workoutData.total_BPM,
            totalReps: workoutData.total_REPS,
            totalKgLifted: workoutData.total_KG_lifted,
            totalTime: workoutData.total_time,
            totalCalories: workoutData.total_calories,
            totalDistance: workoutData.totalDistance,
            workoutType: workoutData.workout_type,
            filterType: workoutData.filter_type,
            filterLayout: workoutData.filter_layout,
            video: workoutData.video,
            title: workoutData.title,
            description: workoutData.description,
            isPrivate: workoutData.private,
            isPlanned: workoutData.planned,
            stockImage: workoutData.stock_image,
            location: workoutData.location,
            createdAt: workoutData.created_at,
            likesCount: workoutData.likes_count,
            commentsCount: workoutData.comments_count,
            repeatsCount: workoutData.repeats_count,
            smallImage: workoutData.image ? workoutData.image.data.small_url : null,
            mediumImage: workoutData.image ? workoutData.image.data.medium_url : null,
            originalImage: workoutData.image ? workoutData.image.data.original_url : null,
            isLiked: workoutData.is_liked,
            isRepeated: workoutData.is_repeated,
            user,
            repeat,
            exercises,
            gym,
        };
    }

    get workout() {
        return this._workout;
    }

    getWorkoutUser(workoutData) {
        let user;

        if (workoutData.user) {
            const workoutUser = new UserModel(workoutData.user.data);
            user = { ...workoutUser._user };
        }

        return user;
    }

    getRepeatData(workoutData) {
        let repeat;

        if (workoutData.repeat_data) {
            const repeatModel = new RepeatModel(workoutData.repeat_data.data);
            repeat = { ...repeatModel.repeat };
        }

        return repeat;
    }

    getExercises(workoutData) {
        let exercises = [];

        if (workoutData.exercises && workoutData.exercises.data) {
            exercises = workoutData.exercises.data.map(exercise => {
                const breakdownModel = new BreakdownModel(exercise);
                return { ...breakdownModel.breakdown };
            });
        }

        return exercises;
    }

    getGym(workoutData) {
        let gym;

        if (workoutData.gym && workoutData.gym.data) {
            const userModel = new UserModel(workoutData.gym.data);
            return { ...userModel.user };
        }

        return gym;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/WorkoutModel.js